import { ERubric } from '../../../types/rubricsLinks';

export function getAnaliticName(rubric?: ERubric, url?: string): string {
  const match = url?.match(/cian\.ru(\/[^?]*)?/);

  switch (rubric) {
    case ERubric.Rent:
      return 'rent';
    case ERubric.Sale:
      return 'sale';
    case ERubric.ResidentialComplexes:
      return 'newobjects';
    case ERubric.Countryside:
      return 'countryside';
    case ERubric.Commercial:
      return 'commercial';
    case ERubric.Mortgage:
      return 'mortgage';
    case ERubric.Services:
      return 'serv_catalogue';
    default:
      return match && match[1] ? match[1].replace(/\//g, '') : '';
  }
}
